import { render, staticRenderFns } from "./NewCoordinator.vue?vue&type=template&id=0365c554&scoped=true&"
import script from "./NewCoordinator.vue?vue&type=script&lang=js&"
export * from "./NewCoordinator.vue?vue&type=script&lang=js&"
import style0 from "./NewCoordinator.vue?vue&type=style&index=0&id=0365c554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0365c554",
  null
  
)

export default component.exports